import { Button, Card } from '@blueprintjs/core';
import Flex from '@components/Flex';
import Heading from '@components/Heading';
import DevText from '@components/Text';
import { useStore } from 'effector-react';
import React, { HTMLAttributes } from 'react';
import { $userEmailSettings } from '../../store/states';
import { userEmailNotificationLevelInformation } from '../../consts';
import { openModal } from '@app/containers/modals/store/events';
import UpdateEmailNotificationLevelModal, {
    UpdateEmailNotificationLevelModalProps,
} from '../../modals/UpdateEmailNotificationLevelModal';

export interface EmailNotificationLevelProps {
    userId: ID;
}

export type Props = HTMLAttributes<HTMLDivElement> & EmailNotificationLevelProps;

const EmailNotificationLevel: React.FC<Props> = ({ userId, ...props }) => {
    const userEmailSettings = useStore($userEmailSettings);

    if (!userEmailSettings) {
        return null;
    }

    const handleOpenUpdateEmailNotificationLevelModal = () => {
        openModal<UpdateEmailNotificationLevelModalProps>({
            ModalComponent: UpdateEmailNotificationLevelModal,
            data: {
                userId,
                currentNotificationLevel: userEmailSettings.min_notification_level,
            },
        });
    };

    const { name, description } = userEmailNotificationLevelInformation[userEmailSettings.min_notification_level];

    return (
        <div {...props}>
            <Heading type="h3" className="mb-1">
                Email notification level
            </Heading>

            <Card compact>
                <Flex align="center" justify="space-between" className="mb-small">
                    <div>
                        <Heading className="mb-1" type="h4">
                            {name}
                        </Heading>
                        <DevText muted>{description}</DevText>
                    </div>

                    <Button onClick={handleOpenUpdateEmailNotificationLevelModal}>Update level</Button>
                </Flex>
            </Card>
        </div>
    );
};

export default EmailNotificationLevel;
